import { ReadingPaneEntrySourceType } from 'owa-calendar-forms-common/lib/schema/ReadingPaneEntrySourceType';
import { ClientItemId } from 'owa-client-ids';
import { lazyStartShowReadingPanePerfDatapoint } from 'owa-calendar-reading-pane-perf';
import { lazyModule, lazyShowReadingPane } from '../index';
import { getId } from '@fluentui/react/lib/Utilities';
import { PopoutType } from 'owa-popout-v2';
import { CalendarComponent } from 'owa-calendar-usage-instrumentation';
import { lazyCreatePerfDatapoint } from 'owa-fluid-perf-datapoints';
import { isFeatureEnabled } from 'owa-feature-flags';
import { FluidOwaSource } from 'owa-fluid-validations';

export default async function showReadingPaneWithPerf(
    itemId: ClientItemId,
    entrySource: ReadingPaneEntrySourceType,
    getSeriesMaster?: boolean,
    isDeeplink?: boolean,
    showModal: boolean = true,
    isInPopoutWindow?: boolean,
    scrollToInsightsOnInitialRender?: boolean
) {
    if (isFeatureEnabled('cal-cmp-fluidCollaborativeSpace')) {
        lazyCreatePerfDatapoint.importAndExecute(FluidOwaSource.CalendarReadingPane);
    }

    const formSessionId = getId('CalendarReadingPane_');
    await lazyStartShowReadingPanePerfDatapoint.importAndExecute(
        formSessionId,
        CalendarComponent.CalendarReadForm,
        isInPopoutWindow ? PopoutType.Deeplink : PopoutType.None,
        entrySource,
        lazyModule.getIsLoaded() /* bundleAlreadyLoaded */
    );

    return lazyShowReadingPane.importAndExecute(
        itemId,
        entrySource,
        getSeriesMaster,
        isDeeplink,
        showModal,
        isInPopoutWindow,
        scrollToInsightsOnInitialRender,
        formSessionId
    );
}
